// Special .dark-focus-outline-w-pad css class on keydown for left sidebar items
const darkFocusOutlineWPadCss = `
    outline-offset: -1px;
    outline: black auto 1px;
    border-radius: 4px;
    background: lightslategray;
    padding-left: 4px; padding-right: 4px;
    margin-left: 5px;  margin-right: 4px;
`;

// Special css class to show on keydown for left sidebar items where no padding change is desired
const darkFocusOutlineCss = `
    outline-offset: -1px;
    outline: black auto 1px;
    border-radius: 4px;
    background: lightslategray;
`;

// Special css class to show on login screen links
const purpleWideFocusOutlineCss = `
    outline-offset: 1px;
    outline: purple auto 3px;
`;

// Special .dark-focus-outline-w-pad css class on keydown for left sidebar items
const lightBlueBgBlackBoxOutlineCss = `
    background-color: lightblue;
    outline-offset: -1px;
    outline-color: black;
    outline-style: solid;
    outline-width: 1px;
    margin-right: -10px;
`;

// Special variant of .dark-focus-outline-w-pad css class for Home link in menu
const myRecordsHomeLinkOutlineCss = `
    background-color: lightblue;
    outline-offset: -1px;
    outline-color: black;
    outline-style: solid;
    outline-width: 1px;
    margin-right: -2px;
    margin-left: -2px;
    padding-left: 42px;
`;

/*
 * Helpers
 */
const buildOutlineHideCss = (cssClass: string) =>
    `.${cssClass}:focus{outline:0}` + `.${cssClass}::-moz-focus-inner{border:0}`;

const buildOutlineCss = (cssClassName: string, cssClassStyleString: string) =>
    `.${cssClassName}:focus{${cssClassStyleString}}` +
    `.${cssClassName}::-moz-focus-inner{${cssClassStyleString}}`;

/**
 * Set up listener to ensure outlines only display when elements are "tabbed" to
 * Hides outline on mouseclick, shows outlines on keypress
 */
(document => {
    // Create dom style element and check for event listener compatibility
    const styleElement = document.createElement('STYLE');
    const domEvents = 'addEventListener' in document;

    // Add event listener to DOM
    const addEventListener = (type, callback) => {
        // Basic cross-browser event handling
        if (domEvents) document.addEventListener(type, callback);
        else (document as any).attachEvent(`on${type}`, callback);
    };

    // Update style element css text
    const setCss = css => {
        // Handle setting of <style> element contents in IE8
        !!(styleElement as any).styleSheet
            ? ((styleElement as any).styleSheet.cssText = css)
            : (styleElement.innerHTML = css);
    };

    // Append created style element to DOM head
    document.getElementsByTagName('HEAD')[0].appendChild(styleElement);

    /*
     * Hide focus outlines on mousedown and show on keydown
     */

    // Hide focus outlines on mousedown
    // Use mousedown so previous focused elements remain highlighted on mouse move
    addEventListener('mousedown', () => {
        setCss(
            // Hide main outline styles
            ':focus{outline:0}::-moz-focus-inner{border:0;}' +
                // Hide outline style in .dark-focus-outline-w-pad css class (left sidebar items)
                buildOutlineHideCss(`dark-focus-outline-w-pad`) +
                // Hide outline style for dark focus outline where no pad change wanted
                buildOutlineHideCss(`dark-focus-outline`) +
                // Hide outline style for dark & wide focus outline
                buildOutlineHideCss(`purple-wide-focus-outline`) +
                // Hide outline style for light blue bg with black surrounding box outline
                buildOutlineHideCss(`lightblue-bg-blackbox-outline`) +
                // Hide outline style for left menu Home link
                buildOutlineHideCss(`my-records-page-home-link-outline`)
        );
    });

    // Show focus outlines on keydown
    addEventListener('keydown', () => {
        setCss(
            // Hide outline style in .dark-focus-outline-w-pad css class (left sidebar items)
            buildOutlineCss(`dark-focus-outline-w-pad`, darkFocusOutlineWPadCss) +
                // Set outline style for dark focus outline where no pad change wanted
                buildOutlineCss(`dark-focus-outline`, darkFocusOutlineCss) +
                // Set outline style for dark & wide focus outline
                buildOutlineCss(`purple-wide-focus-outline`, purpleWideFocusOutlineCss) +
                // Set outline style for light blue bg with black surrounding box outline
                buildOutlineCss(`lightblue-bg-blackbox-outline`, lightBlueBgBlackBoxOutlineCss) +
                // Set outline style for left menu Home link (lightblue-bg-blackbox-outline variant)
                buildOutlineCss(`my-records-page-home-link-outline`, myRecordsHomeLinkOutlineCss)
        );
    });
})(document);
